module.exports = __webpack_public_path__ + "img/16.9c88c53f.png";